export default __webpack_public_path__ + "static/media/elementsCoin.cb9f075d.svg";